import { BoneOutlined, MeshOutlined, ModelOutlined, NodeOutlined } from '@easyv/react-icons';
import React from 'react';

export function GetIcon(type: string, size: number = 16): React.ReactNode {
  switch (type) {
    case 'Model':
      return <ModelOutlined size={size} />;
    case 'Mesh':
      return <MeshOutlined size={size} />;
    case 'Bone':
      return <BoneOutlined size={size} />;
    case 'Object':
      return <NodeOutlined size={size} />;
  }
}
